import Modal from "../../Components/Modal";
import { getYouTubeEmbedUrl } from "../../utils";
import React from 'react'
import { ButtonSpan } from "../../Components/Button";
let YoutubeModal = ({
                      youtubeUrl,
                      closeModal,
                    }) => {


  return (
    <Modal>
      <div className="modal">
        <div
          className="relative w-full modal-inner"
          style={{
           width: "90%",
          }}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <ButtonSpan
            className="m-3 absolute pin-t pin-r z-10"
            onClick={closeModal}
          >
            <i className="fas fa-times-circle fa-2x ml-3" />
          </ButtonSpan>
          <div className={'pt-12'}>
            <iframe
              className="w-full"
              style={{
                height: "50vw"
              }}

              id="ytplayer"
              src={getYouTubeEmbedUrl(youtubeUrl)}
              frameBorder="2"
              allowFullScreen
            />
          </div>

        </div>
      </div>
    </Modal>
  )


}

export default YoutubeModal